export const getUrlParameterValue = (key: string): string | null => {
	const url = location.href;
	key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
	const regexS = "[\\?&]" + key + "=([^&#]*)";
	const regex = new RegExp(regexS);
	const results = regex.exec(url);
	return results === null ? null : results[1];
};